import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import "../assets/styles/stylesheets/daterangepicker.css";
import { Typography, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ExportModal = ({ open, onClose, onDownload }) => {
  const [mobileNumber, setMobileNumber] = React.useState("");
  const [dateRange, setDateRange] = React.useState({
    start: moment().subtract(29, "days"),
    end: moment(),
  });
  const [dateFilter, setDateFilter] = React.useState(false);
  const [showDownload, setShowDownload] = React.useState(false);

  const { start, end } = dateRange;
  const label = start.format("MMM D, YYYY") + " - " + end.format("MMM D, YYYY");

  React.useEffect(() => {
    if (open) {
      setMobileNumber("");
      setDateRange({ start: moment().subtract(29, "days"), end: moment() });
      setDateFilter(false);
      setShowDownload(false);
    }
  }, [open]);

  React.useEffect(() => {
    // Show download button if mobile number has at least 10 digits
    setShowDownload(mobileNumber.length >= 10);
  }, [mobileNumber]);

  const handleMobileNumberChange = (event) => {
    const value = event.target.value.replace(/\D/g, ""); // Only allow digits
    setMobileNumber(value);
  };

  const handleCallback = (start, end) => {
    setDateRange({ start, end });
    setDateFilter(true);
  };

  const handleClickOnCancel = () => {
    setDateRange({ start: moment().subtract(29, "days"), end: moment() });
    setDateFilter(false);
  };

  const handleDownload = () => {
    if (mobileNumber.length >= 10 && onDownload) {
      const startDate = moment(dateRange.start).format("YYYY-MM-DD");
      const endDate = moment(dateRange.end).format("YYYY-MM-DD");
      onDownload(mobileNumber, startDate, endDate);
    }
  };

  const handleClose = () => {
    setMobileNumber("");
    setDateRange({ start: moment().subtract(29, "days"), end: moment() });
    setDateFilter(false);
    setShowDownload(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <Grid container id="modal-title">
        <Grid item xs={6}>
          <Typography className="f-20 font-weight-600 modalTitle heading-text-color">
            <DialogTitle>Export Data</DialogTitle>
          </Typography>
        </Grid>
        <Grid item xs={6} aria-label="Close icon">
          <Typography
            align="right"
            className="cursor-hover gray7 m-20"
            aria-label="Close icon"
          >
            <CloseIcon
              onClick={() => {
                handleClose();
              }}
              aria-label="Close icon"
            />
          </Typography>
        </Grid>
      </Grid>
      <DialogContent>
        <Grid container spacing={1} lg={12} md={12} xs={12} className="mt-10">
          <Grid item lg={6} md={6} xs={12}>
            <Typography className="gray8 font-weight-500 mt-5 f-14">
              Mobile Number<span className="gray9">*</span>
            </Typography>
            <TextField
              type="text"
              className="form-control input-group mb-0 inputcontrasts"
              margin="normal"
              placeholder="Enter mobile number"
              value={mobileNumber}
              onChange={handleMobileNumberChange}
              inputProps={{ maxLength: 10 }}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <Typography className="gray8 font-weight-500 mt-5 f-14">
              Date Range
            </Typography>
            <DateRangePicker
              initialSettings={{
                startDate: start.toDate(),
                endDate: end.toDate(),
                ranges: {
                  Today: [moment().toDate(), moment().toDate()],
                  Yesterday: [
                    moment().subtract(1, "days").toDate(),
                    moment().subtract(1, "days").toDate(),
                  ],
                  "Last 7 Days": [
                    moment().subtract(6, "days").toDate(),
                    moment().toDate(),
                  ],
                  "Last 30 Days": [
                    moment().subtract(29, "days").toDate(),
                    moment().toDate(),
                  ],
                  "This Month": [
                    moment().startOf("month").toDate(),
                    moment().endOf("month").toDate(),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month").toDate(),
                    moment().subtract(1, "month").endOf("month").toDate(),
                  ],
                },
              }}
              onCallback={handleCallback}
              onCancel={handleClickOnCancel}
            >
              <div
                id="reportrange"
                className={
                  dateFilter
                    ? "col-4 chip-dropdown-active position-issue"
                    : "col-4"
                }
                style={{
                  background: "#fff",
                  color: "#344054",
                  cursor: "pointer",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  border: "1px solid #667085",
                  width: "100%",
                  marginTop: "8px",
                }}
              >
                <i className="fa fa-calendar"></i>&nbsp;
                <span style={{ color: dateFilter && "#fff" }}>
                  {label}
                </span>{" "}
                <i className="fa fa-caret-down"></i>
              </div>
            </DateRangePicker>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          className="btn secondary-button m-r-10"
          aria-label="button"
          onClick={handleClose}
        >
          Cancel
        </Button>
        {showDownload && (
          <Button
            onClick={handleDownload}
            className="btn primary-button"
            aria-label="button"
            startIcon={<FileDownloadIcon />}
          >
            Download Excel
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ExportModal;
